<template>
<div class="md:flex flex-wrap min-h-screen relative" >

  <!-- header -->
  <div class="bg-white md:fixed top-0 left-0 w-full h-20 flex items-center botborder z-10 relative">
    <img v-if="$store.state.dash.logoURL"  class="pt_logo h-10 block mx-auto" :src="$store.state.dash.logoURL"/>
    <img v-else  class="w-48 block mx-auto" src="@/assets/images/logo/logo.png"/>
  </div>

  <!-- inputs -->
  <div class="w-full py-6 md:pt-18 md:w-118 lg:w-200 bg-white md:shadow-setupside px-8 lg:px-24 min-h-full">
    <div>
    <h3 class="mt-10 mb-6 text-primary relative w-full font-medium pr-12 text-3xl lg:text-4xl inline-block">Welcome!</h3>
    <p class="mb-6 mt-1">Please sign up below <span class="font-medium">using the email address</span> on which you've received your <span class="font-medium">collaboration invite.</span></p>
    <span v-if="registerErrorMsg" class="text-danger block my-6">{{ registerErrorMsg }}</span>
      <vs-input
        v-validate="'required|min:3|max:20'"
        data-vv-validate-on="blur"
        data-vv-as="First name"
        label="First Name"
        name="displayName"
        placeholder="John"
        v-model="displayName"
        class="w-full" />
        <span class="text-primary my-2">{{ errors.first('displayName') }}</span>

      <vs-input
        v-validate="'required|email|max:60'"
        data-vv-validate-on="blur"
        name="email"
        type="email"
        label="Email"
        placeholder="john@hancock.com"
        v-model="email"
        class="w-full mt-6" />
      <span class="text-primary">{{ errors.first('email') }}</span>

      <vs-input
        ref="password"
        type="password"
        data-vv-validate-on="blur"
        v-validate="'required|min:6|max:15'"
        name="password"
        label="Choose Password"
        placeholder="Choose a password"
        @blur="checkPWAlpha"
        v-model="password"
        class="w-full mt-6" />
        <span class="text-primary">{{ errors.first('password') ? errors.first('password') : passwordMsg }}</span>
      <vs-button class="w-full font-semibold mt-8 mb-4" size="large" @click="registerUser" :disabled="!validateForm">Get started</vs-button>
      <p>By clicking this button, you agree to the <a href="https://feedback.link/tou.html" target="_blank">Terms</a> and <a href="https://feedback.link/privacy.html" target="_blank">Privacy Policy.</a></p>
    </div>
  </div>

  <!-- aside -->
  <div class="w-full py-8 md:py-0 md:fixed md:w-full md:top-20 md:pl-118 lg:pl-200 md:pb-20 md:min-h-full z-m1 md:flex items-center " >
    <div class="w-full px-5 md:px-20 suaside text-dark ">
      <div class="text-dark text-lg text-left pb-10">
        <p class="text-center text-xl mb-4">Collect <span class="font-medium">reviews</span>, <span class="font-medium">feedback</span> or <span class="font-medium">social shares</span> from customers.</p>
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/3 text-center pt-4">
            <img src="@/assets/images/misc/surs.png" class="w-16 block mx-auto"/>
            <p class="inline-block mx-auto my-3 text-lg font-medium">✔️Reviews & Shares</p>
            <p class="block mx-auto mb-2" style="max-width: 20rem;">Send invites for reviews or feedback via email or text (SMS), or simply point customers to a link.</p>
            </div>
          <div class="vx-col w-full xl:w-1/3 text-center pt-4">
            <div class="bgdiv">
            <img src="@/assets/images/misc/sus.png" class="w-16 block mx-auto"/>
            <p class="inline-block mx-auto my-3 text-lg font-medium">✔️Survey</p>
            <p class="block mx-auto mb-2" style="max-width: 20rem;">Responders who prefer not to review can select "No thanks" and will move on to either leave a testimonial, or answer custom survey questions. You have full control over your survey.</p>
            </div>
          </div>
          <div class="vx-col w-full xl:w-1/3 text-center pt-4">
            <div class="bgdiv">
            <img src="@/assets/images/misc/susc.png" class="w-16 block mx-auto"/>
            <p class="inline-block mx-auto my-3 text-lg font-medium">✔️Showcase</p>
            <p class="block mx-auto mb-2" style="max-width: 22rem;">Improve conversion on your website by showcasing your best reviews and feedback with showcase widgets that elegantly display your reviews and testimonials.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>


function isAlphaNumeric(myString) {
  return (/\d/.test(myString) && (myString.match(/[a-z]/i)))
}

export default {
  data () {
    return {
      registerErrorMsg: false,
      displayName: '',
      email: '',
      password: '',
      confirm_password: '',
      isTermsConditionAccepted: true,
      passwordMsg: ''
    }
  },
  created() {
    //noconsoleconsole.log(this.$route.path)
    this.displayName = typeof this.$route.query.name !== "undefined" ? this.$route.query.name : ''
    this.email = typeof this.$route.query.email !== "undefined" ? this.$route.query.email : ''
  },
  watch: {
    password() {
      this.passwordMsg = ''
    }
  },
  computed: {
    validateForm () {
      return this.passwordMsg === '' && !this.errors.any() && this.displayName !== '' && this.email !== '' && this.password !== '' && this.isTermsConditionAccepted === true
    }
  },
  methods: {
    checkPWAlpha () {
      if (this.password !== '') {
        if (!isAlphaNumeric(this.password)){
          this.passwordMsg = 'Your password should contain at least one number and one letter.'
        }
      }
    },
    setErrorMessage (msg){
      this.registerErrorMsg = msg
    },
    registerUser () {
      // If form is not validated or user is already login return

      this.$vs.loading()

      this.registerErrorMsg = false

      if (!this.validateForm) return

      const payload = {
        userDetails: {
          displayName: this.displayName,
          email: this.email,
          password: this.password
        }
      }

      let token = typeof this.$route.query.token !== "undefined" ? this.$route.query.token : false

      this.$store.dispatch('auth/VALIDATE_COLLABORATOR_REDEEEM', {
        email: this.email,
        displayName: this.displayName,
        password: this.password,
        token: token
      }).then((res) => {
        if (res !== false) {
          //noconsoleconsole.log('created, redeemed')
            this.$store.dispatch('auth/login', {
              userDetails: {
                email: this.email,
                password: this.password
              }
            }).then(() => {
              this.$vs.loading.close()
              this.$router.push('/dash/responses')
            }).catch(() => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Signup',
                text: 'Oops! We had an issue in signing you up. Please try again or reach out to support with the code \'vi\'.',
                color: 'primary',
                time: 50000,
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
        } else {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Signup',
            text: 'Please make sure you sign up with the email address to which your collaboration invite was sent. Please try again or reach out to with the code \'vi\'.',
            color: 'primary',
            time: 50000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      }).catch((e) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Signup',
          text: 'Please make sure you sign up with the email address to which your collaboration invite was sent. Please try again or reach out to with the code \'vi\'.',
          color: 'primary',
          time: 50000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })


      /*

    */

    }
  }
}

</script>


<style lang="scss">

  .bgdiv {
      //background-color: #FBEFFF;
      display: inline-block;
      border-radius: 50px;
  }

  .icnbg {
    background: url('~@/assets/images/misc/subg.png');
    background-size: 910px 883px;
    background-color: white;
    //background-color: rgba(var(--vs-primary),1) !important;
    animation: spin 260s ease-in infinite;
    //background-repeat: no-repeat;
    //background-origin: content-box;
  }

  .tlblock {
    position: relative;
    z-index: 10;
    //top: -6px;
    //padding: 1px 4px;
    margin-top: 0.6rem;
    border-radius: 3px;
    &.pl {
      //background: #E5B7F4;
    }
    &.bl {
      //background: #CBB7F4;
    }
    &.pi {
      //background: #F0B7E7;
    }

  }


  @keyframes spin {
    50% { background-size: 1456px 1412.8px; }
  }
  @-webkit-keyframes spin {
    50% { background-size: 1456px 1412.8px; }
  }


</style>
